module.exports = __webpack_public_path__ + "img/Logo_KasPro_White.638fa6ee.png";